import { ContactType } from '@components/Invite/Contact';
import { AvatarDetailFragment, File } from '@graphql/generated';

type ChatUser = {
  id: string;
  name?: string | null;
  email?: string;
  avatar?: AvatarDetailFragment | null;
  friendRequestPending?: boolean | null;
};

export const convertUsersToContacts = (contacts: ChatUser[]): ContactType[] => {
  const launchOptimistic = contacts.map(function (u) {
    return {
      ...u,
      displayName: u.name ?? '',
      initials: '',
      avatar: (u.avatar ?? null) as unknown as File | null,
      email: u.email ?? undefined,
      friendRequestPending: u.friendRequestPending ?? false,
      users: [],
      type: '',
      memberCount: 0,
    };
  });
  return launchOptimistic;
};
